import antdLocale from '@aplus-frontend/antdv/es/locale/zh_CN';
import login from './login.json';

export default {
  antdLocale,
  login
};
